import { render, staticRenderFns } from "./PCompany.vue?vue&type=template&id=0e13888c&"
import script from "./PCompany.vue?vue&type=script&lang=ts&"
export * from "./PCompany.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports